import MoneyFormat from "@/src-refactor/modules/shared/helpers/moneyFormat.helper";
import {
  Agent,
  IPropertyDetailsResponse,
  ValidationDocument
} from "../../../../store/qrtk/services/realestate/responses/property-details.response";
import getYouTubeVideoIdByUrl from "@/src-refactor/modules/shared/helpers/youtube.helper";
import {
  PROPERTIES_STATUS_FOR_ID,
  PropertyStatus
} from "@/src-refactor/modules/shared/model/const/property/real-estate-status";
import categorizeFeaturesHelper from "@/src-refactor/modules/shared/helpers/categorize-features.helpers";
import { O_CONDICTION_PROPERTY_FOR_NAME } from "@/src-refactor/modules/shared/model/const/property/condition-status.const";
import { I_RealestateCard } from "@/src-refactor/modules/shared/model/interface/realestate-card.interface";
import dayjs from "dayjs";
import { replaceHtmlEntities } from "@/src-refactor/modules/shared/helpers/parse-html-values";
import { TPROPERTIES_STATUS_OBJECT } from "@/src-refactor/modules/shared/model/const/realestate/property-status.const";
import {
  C_BUSINESS_TYPE_ID,
  O_BUSINESS_TYPE
} from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { O_COMMISSION_RENT_ALL } from "@/src-refactor/modules/shared/model/const/property/comission_rent.const";
import propertyDetailToCardAdapter from "@rf/property/module/adapters/propertyDetailToCardAdapter";
import { ICardProperty } from "@rf-model/card-property.model";
import { RemaxGlobalStatusSync } from "@rf-l1/page/details/card-remax-global/MxDetailCardAgent";
import { RemaxGlobalAdapter } from "@/src-refactor/modules/shared/helpers/remax-global.adapter";
import { getConditionStatusLabel } from "@/src-refactor/modules/shared/components/refactor/helpers/property/prepare-condition-status-label";
import propertyBrochureAdapter from "@rf/property/module/adapters/propertyBrochureAdapter";
import { PropertyBrochureData } from "@rf/property/module/hooks/usePropertyBrochurePdf";

export const detailsPropertiesAdapter = (
  response: IPropertyDetailsResponse
): I_DetailsPropertiesAdapter => {
  const brochure = propertyBrochureAdapter(response);
  const remaxGlobal = prepareRemaxGlobal(response);
  const propertyCharacterist = {
    Gabinetes: response.improvements_list.find(item => item.name === "Gabinetes")
      ? response.improvements_list.find(item => item.name === "Gabinetes")?.value
      : null,
    Puertas: response.improvements_list.find(item => item.name === "Puertas")
      ? response.improvements_list.find(item => item.name === "Puertas")?.value
      : null,
    Pisos: response.improvements_list.find(item => item.name === "Pisos")
      ? response.improvements_list.find(item => item.name === "Pisos")?.value
      : null,
    Marcos: response.improvements_list.find(item => item.name === "Marcos")
      ? response.improvements_list.find(item => item.name === "Marcos")?.value
      : null,
    Ventanas: response.improvements_list.find(item => item.name === "Ventanas")
      ? response.improvements_list.find(item => item.name === "Ventanas")?.value
      : null,
    Techo: response.improvements_list.find(item => item.name === "Techo")
      ? response.improvements_list.find(item => item.name === "Techo")?.value
      : null,
    Closets: response.improvements_list.find(item => item.name === "Closets")
      ? response.improvements_list.find(item => item.name === "Closets")?.value
      : null
  };

  // const getPrices = (item: IPropertyDetailsResponse) => {
  //   if (item.project_id) {
  //     return {
  //       rent: null,
  //       sale: `${item.currency_symbol}$ ${MoneyFormat(item.minimum_price)} - ${
  //         item.currency_symbol
  //       }$ ${MoneyFormat(item.maximum_price)}`,
  //     };
  //   } else {
  //     return {
  //       rent:
  //         item.alternate_price && +item?.alternate_price > 0
  //           ? `${item.currency_symbol}$ ${MoneyFormat(item.alternate_price)}`
  //           : null,
  //       sale: item.price
  //         ? `${item.currency_symbol}$  ${MoneyFormat(+item.price)}`
  //         : null,
  //     };
  //   }
  // };

  const getPrices = (item: IPropertyDetailsResponse) => {
    if (item.project) {
      const prices = {
        rent: null,
        sale: `
        ${item.currency_symbol} $${MoneyFormat(item?.minimum_price)} - 
        ${item?.currency_symbol} $${MoneyFormat(item?.maximum_price)}`
      };
      return [
        {
          label: "Venta",
          value: prices.sale
        }
      ];
    } else {
      const business_type = O_BUSINESS_TYPE[item.business_type];
      if (!business_type) {
        return [
          {
            label: "Error",
            value: "Error"
          }
        ];
      }
      const prices = {
        alternate_price:
          +item?.alternate_price && +item?.alternate_price > 0
            ? `${item?.currency_alternate_id == 1 ? "RD" : "US"} $${MoneyFormat(
                item?.alternate_price
              )}`
            : null,
        price:
          item?.price && +item?.price > 0
            ? `${item?.currency_symbol} $${MoneyFormat(+item?.price)}`
            : null,
        label: "Error"
      };

      if (business_type.id == C_BUSINESS_TYPE_ID.RENT) {
        return [
          {
            label: business_type.name,
            value: prices.price
          }
        ];
      } else if (business_type.id == C_BUSINESS_TYPE_ID.SALE) {
        return [
          {
            label: business_type.name,
            value: prices.price
          }
        ];
      } else if (business_type.id == C_BUSINESS_TYPE_ID.SALE_AND_RENT) {
        return [
          {
            label: "Venta",
            value: prices.price
          },
          {
            label: "Alquiler",
            value: prices.alternate_price
          }
        ];
      } else if (business_type.id == C_BUSINESS_TYPE_ID.RENT_FURNISHED) {
        return [
          {
            label: "Alquiler Amueblado",
            value: prices.price
          }
        ];
      } else if (business_type.id == C_BUSINESS_TYPE_ID.SALE_AND_FURNISHED_RENTAL) {
        return [
          {
            label: "Venta Amueblado",
            value: prices.price
          },
          {
            label: "Alquiler Amueblado",
            value: prices.alternate_price
          }
        ];
      } else if (
        business_type.id == C_BUSINESS_TYPE_ID.SALE_AND_RENTAL_OF_WHITE_GOODS
      ) {
        return [
          {
            label: "Venta de Línea Blanca",
            value: prices.price
          },
          {
            label: "Alquiler de Línea Blanca",
            value: prices.alternate_price
          }
        ];
      } else if (business_type.id == C_BUSINESS_TYPE_ID.SALE_FURNISHED) {
        return [
          {
            label: "Venta Amueblado",
            value: prices.price
          }
        ];
      } else if (business_type.id == C_BUSINESS_TYPE_ID.WHITE_LINE_RENTAL) {
        return [
          {
            label: "Alquiler de Línea Blanca",
            value: prices.price
          }
        ];
      } else if (business_type.id == C_BUSINESS_TYPE_ID.WHITE_LINE_SALES) {
        return [
          {
            label: "Venta de Línea Blanca",
            value: prices.price
          }
        ];
      } else {
        return [
          {
            label: "Error",
            value: prices.label
          }
        ];
      }
    }
  };

  const principalData: IPrincipalData = {
    remaxGlobal,
    parent_id: response.parent_id,
    is_collection: response.is_collection ? true : false,
    is_project: Boolean(response.project),
    bathrooms: response.bathrooms ? response.bathrooms : null,
    business_type: response.business_type,
    businesstype_id: response.businesstype_id,
    leadCounts: Array.isArray(response.leadCounts)
      ? response.leadCounts.map(item => ({
          name: item.name,
          total_count: item.total_count
        }))
      : [],
    getLeadCount: (name: string) =>
      principalData.leadCounts.find((item: any) => item.name === name)?.total_count,
    address: response.address,
    is_conflictive: response.is_conflictive,
    likes_counter: response.likes_counter,
    views_counter: response.views_counter,
    shares_counter: response.shares_counter,
    delivers: response.delivers,
    total_views: MoneyFormat(response.remaxrd_views) ?? 0,
    realstatetype_id: response.realstatetype_id,
    bedrooms: response.bedrooms ? response.bedrooms : null,
    has_important_alert: response.has_important_alert,
    important_alert_message: response.important_alert_message,
    description:
      response.info.length > 0
        ? wrapInPTags(response.info[0].description ?? "")
        : wrapInPTags(response.description ?? ""),
    general_information: {
      business_details: response.business_type,
      city: response.city,
      property_status: getConditionStatusLabel(
        response.condition_status,
        response.business_type
      ),
      property_use: response.improvements_list
        .filter(item => item.name === "Uso")
        .map(item => replaceHtmlEntities(item.value))
        .join(", "),
      ref_point: response.reference,
      position: response.improvements_list
        .filter(item => item.name === "Ubicaci&oacute;n")
        .map(item => replaceHtmlEntities(item.value))
        .join(", "),
      sector: response.sector,
      type_of_arrangement: response.arrangement,
      escrow_name: response.trust_name,
      delivers: response.delivers
    },
    half_bathrooms: response.half_bathrooms,
    id: response.id,
    improvements: response.improvements_list
      .filter(item => item.name === "Mejoras")
      .map(item => item.value),
    latitude: response.latitude,
    longitude: response.longitude,
    location: `${response.sector}, ${response.city}`,
    pictures: response.pictures.map(item => item.pictures),
    price: getPrices(response),
    property_characteristics: Object.entries(propertyCharacterist)
      .filter(([label, value]) => value !== null)
      .map(([label, value]) => ({ label, value })),
    title:
      response.realstate_type == "Proyecto"
        ? `${response.realstate_type} de ${response.projecttype?.toLowerCase()} en ${
            response.sector
          } ${response.city}`
        : `${response.realstate_type} en ${response.sector} ${response.city}`,
    virtual_folders: {
      dropbox: response.dropbox_link,
      google_drive: response.google_drive_link
    },
    property_status:
      PROPERTIES_STATUS_FOR_ID[
        response.status_id as keyof typeof PROPERTIES_STATUS_FOR_ID
      ],
    parking_spots: response.parking_spots ? response.parking_spots : null,
    sqm_construction: response.sqm_construction
      ? `${response.sqm_construction}m²`
      : null,
    sqm_land: response.sqm_land ? `${response.sqm_land}m²` : null,
    realstate_type: response.realstate_type,
    virtual_tour: response.realstate_tour_url,
    eng_description:
      response.info.length > 1 ? wrapInPTags(response.info[1].description) : null,
    // changesLog: response.changes ?? []
    is_inhabited: response.visit_status === 1 ? "Si" : "No",
    name: response.name,
    pumps: response.pumps,
    floor_level: response.floor_level,
    floors_total: response.floors_total,
    maintenance_fee: response.maintenance_fee,
    visit: response.visit,
    hasRestorableUnits: response.has_restorable_units ? true : false
  };

  const videos = response.videos.map(item => getYouTubeVideoIdByUrl(item.path));

  const documents: Documents[] =
    response?.documents?.map(item => ({
      name: item.type.description,
      url: item.filename
    })) ?? [];

  const owners = response.owners.map(item => ({
    name: item.name,
    email: item.email,
    phoneNumber: item.phone ?? item.mobile,
    id: item.id,
    is_conflictive: item.is_conflictive
  }));

  //   can_alterestate_sync = El agente quiere sincronizar
  // is_alterestate_sync = Esta sincronizada con alterestate
  // is_alterestate_published = El agente quiere publicar la dentro de la red interna de alterestate, solo se llena si can_alterestate_sync = 1
  // alterestate_commission = Comision del agente pulicada en alterestate, solo se llena si is_alterestate_published = 1
  const alterstate: IAlterestate = {
    is_published: response.is_alterestate_published,
    is_sync: response.is_alterestate_sync,
    commission: response.alterestate_commission,
    is_failed: response.alterestate_failed_sync
  };

  const professionalFees: IProfessionalFees = {
    total_commission: response.total_comission,
    guaranteed_commission: response.guaranteed_comission,
    lease_commission: response.lease_commission
      ? O_COMMISSION_RENT_ALL[response.lease_commission].name
      : null
  };

  const getId = (item: IPropertyDetailsResponse) => {
    if (item.project_id) {
      return item.project_id;
    } else {
      return item.id;
    }
  };

  const card: I_RealestateCard = {
    title: `${response.realstate_type} en ${response.sector} ${response.city}`,
    name: response.name,
    agents: response.agents.map(x => x.name).join(", "),
    is_project: response.project_id ? true : false,
    project_id: response.project_id,
    id: response.id,
    likes_counter: response.likes_counter,
    views_counter: response.views_counter,
    shares_counter: response.shares_counter,
    status: PROPERTIES_STATUS_FOR_ID[
      response.status_id as keyof typeof PROPERTIES_STATUS_FOR_ID
    ] as unknown as PropertyStatus,
    features: categorizeFeaturesHelper(response.improvements_list),
    improvements: {
      bathrooms: response.bathrooms,
      bedrooms: response.bedrooms,
      parking_lot: response.parking_spots,
      sqm_construction: response.sqm_construction,
      sqm_land: response.sqm_land,
      floor_level: response.floor_level,
      floors_total: response.floors_total,
      pumps: response.pumps
    },
    location: `${response.sector}, ${response.city}`,
    prices: getPrices(response),
    commission_percents: `10%`,
    lease_commission: response.lease_commission,
    business_type_base: 0,
    pictures: response.pictures.length > 0 ? response.pictures[0].pictures : "",
    condition: O_CONDICTION_PROPERTY_FOR_NAME[response.condition_status] ?? null,
    agents_info_full: response.agents.map(x => ({
      name: x.name,
      id: x.id,
      email: x.email,
      agency_id: x?.agency_id ?? null
    }))
  };

  const validationDocuments = getValidationDocuments(response);
  const validationDocumentsAlerts = getMessageAlertValidation(response);

  const formatDateTime = (dateTime: string): string | null =>
    dateTime ? dayjs(dateTime).format("DD/MM/YYYY hh:mm a") : null;

  const changesLog = response.changes?.map(
    item =>
      ({
        name_autor: item.author_name ?? "user",
        date: formatDateTime(item.created_at),
        changes: {
          name: {
            ...item.changes?.name,
            variant: "arrow",
            name: "Nombre",
            show: item?.changes?.name?.new ? true : false
          },
          address: {
            ...item?.changes?.address,
            variant: "arrow",
            name: "Direccion",
            show: item?.changes?.address?.new ? true : false
          },
          businesstype: {
            ...item.changes.businesstype,
            variant: "arrow",
            name: "Tipo de Negocio",
            show: item?.changes?.businesstype?.new ? true : false
          },
          description: {
            ...item.changes.description,
            new: item.changes?.description?.new,
            old: item.changes?.description?.old,
            variant: "arrow",
            name: "Descripción",
            show: item?.changes?.description?.new ? true : false
          },
          documents: {
            ...item.changes.documents,
            docs: item?.changes?.documents?.changed?.join(", "),
            variant: "arrow",
            name: "Documentos",
            show: item?.changes?.documents?.changed?.length > 0
          },
          images: {
            ...item.changes?.images,
            variant: "arrow",
            name: "Imágenes",
            show: item?.changes?.images?.total > 0
          },
          latitude: {
            ...item.changes?.latitude,
            variant: "arrow",
            name: "Latitud",
            show: item?.changes?.latitude?.new ? true : false
          },
          longitude: {
            ...item.changes?.longitude,
            variant: "arrow",
            name: "Longitud",
            show: item?.changes?.longitude?.new ? true : false
          },
          price: {
            ...item.changes.price,
            variant: "arrow",
            name: "Precio",
            new: `${response.currency_symbol} ${MoneyFormat(
              +item.changes?.price?.new
            )}`,
            old: `${response.currency_symbol} ${MoneyFormat(
              +item.changes?.price?.old
            )}`,
            show: item?.changes?.price?.new ? true : false
          },
          sector: {
            ...item.changes.sector,
            variant: "arrow",
            name: "Sector",
            show: item?.changes?.sector?.new ? true : false
          },
          videos: {
            total: item.changes?.videos?.total ?? null,
            uploaded: item.changes?.videos?.uploaded ?? null,
            variant: "multimedia",
            name: "Videos",
            show: item.changes?.videos?.total > 0
          }
        }
      } as ChangeLogs)
  );
  const dataLog: IDataLog = {
    created_property: formatDateTime(response.created),
    expires_property: formatDateTime(response.expires),
    last_modified_date: formatDateTime(response.modified),
    last_user_modified_property: response.lastmodifier,
    property_creator: response.creator,
    property_reactivation_date: response.reactivated
      ? formatDateTime(response.reactivated)
      : null,
    property_user_published: response.availableby_name,
    property_publication_date: response.activated
      ? formatDateTime(response.activated)
      : null,
    property_dropped_date: response.drop_date
      ? formatDateTime(response.drop_date)
      : null,
    last_user_dropped_property: response.dropper ? response.dropper : null,
    property_resolve_conflict_date: response.resolved_conflict
      ? formatDateTime(response.resolved_conflict)
      : null,
    last_user_resolve_conflict_property: response.resolved_conflict_by
      ? response.resolved_conflict_by
      : null,
    property_out_negotiation_date: response.business_expire_date
      ? formatDateTime(response.business_expire_date)
      : null,
    property_out_negotiation_days: response.in_business_days
      ? response.in_business_days
      : null,
    last_user_reactivated_property: response.reactivator
      ? response.reactivator
      : null,
    resolved_conflict_by: response.resolved_conflict_by
      ? response.resolved_conflict_by
      : null,
    activated: response.activated ? formatDateTime(response.activated) : null,
    conflict_resolver: response.conflict_resolver ? response.conflict_resolver : null
  };

  const project = {
    ...response.project,
    buildings: response?.project?.buildings.map(item => ({
      ...item,
      delivers: item.delivers ? item.delivers : response.project.delivers
    }))
  };

  const agents = response.agents.map(item => {
    return {
      ...item,
      picture: validateUrlAgents(item.picture) ? item.picture : null
    };
  });
  const cardProperty = propertyDetailToCardAdapter(response);

  return {
    brochure,
    principalData,
    urlVideos: videos,
    agents: agents,
    documents,
    owners,
    alterstate,
    card: Array(card),
    dataLog,
    professionalFees,
    changesLog,
    is_conflictive: response.is_conflictive,
    project,
    validationDocuments,
    validationDocumentsAlerts,
    cardProperty: propertyDetailToCardAdapter(response)
  };
};

const prepareRemaxGlobal = (
  data: IPropertyDetailsResponse
): RemaxGlobalStatusSync => {
  return RemaxGlobalAdapter({
    sync_error_message: data.sync_error_message,
    sync_status: data.sync_status
  });
};
const wrapInPTags = (text: string): string => {
  // Check if the text is already wrapped in <p> tags
  if (!text?.startsWith("<p>") || !text?.endsWith("</p>")) {
    // If not, wrap the text in <p> tags
    text = `<p>${text}</p>`;
  }
  return text;
};

const validateUrlAgents = (url: string) => {
  const patron = /^https?:\/\/.*\.(png|jpe?g|gif|bmp|tiff)$/i;
  return patron.test(url);
};

const getValidationDocuments = (response: IPropertyDetailsResponse) => {
  if (
    Object(response).hasOwnProperty("project") &&
    Object(response.project).hasOwnProperty("validation_documents") &&
    Object(response).hasOwnProperty("validation_document_alerts")
  ) {
    const prepareMessageAlert = (item: ValidationDocument) => {
      if (item.status === "pending") {
        return `El documento está pendiente `;
      } else if (item.status === "approved") {
        return `Documento aprobado `;
      } else if (item.status === "rejected") {
        return `Documento rechazado `;
      }
    };

    return response.project.validation_documents.map(item => {
      const validation = response?.validation_document_alerts?.find(
        x => x.document_type_id === item.document_type_id
      );
      return {
        id: item.id,
        name: item.document_type_name,
        url: item.filename,
        dateExpedition: item.expedition_date,
        status: {
          pending: item.status === "pending",
          approved: item.status === "approved",
          rejected: item.status === "rejected"
        },
        status_comment: item.status_comment,
        has_alert: validation ? true : false,
        message_alert: validation ? prepareMessageAlert(item) : null,
        validated_at: item.validated_at
      } as IValidationDocuments;
    });
  } else {
    return [];
  }
};
const getMessageAlertValidation = (response: IPropertyDetailsResponse) => {
  if (response?.validation_document_alerts?.length === 0) {
    return [];
  } else if (
    Object(response).hasOwnProperty("project") &&
    Object(response.project).hasOwnProperty("validation_documents") &&
    Object(response).hasOwnProperty("validation_document_alerts")
  ) {
    return response.validation_document_alerts.map(item => {
      const status = response.project.validation_documents.find(
        x => x.document_type_id === item.document_type_id
      );
      if (!status) {
        return {
          isExpired: dayjs(new Date()).isAfter(dayjs(item.alert_at)),
          id: item.id,
          name: item.document_type_name,
          message: `El documento ${
            item.document_type_name
          } debe ser suministrado, en caso de no ser suministrado, la propiedad se le dará de baja el ${dayjs(
            item.drop_at
          ).format("DD/MM/YYYY")}`
        };
      } else if (status.status === "pending") {
        return {
          isExpired: false,
          id: item.id,
          name: item.document_type_name,
          message: `El documento ${
            item.document_type_name
          } está pendiente aprobación, en caso de no ser aprobado, la propiedad se le dará de baja el ${dayjs(
            item.drop_at
          ).format("DD/MM/YYYY")}`
        };
      } else if (status.status === "rejected") {
        return {
          isExpired: false,
          id: item.id,
          name: item.document_type_name,
          message: `El documento ${
            item.document_type_name
          } ha sido rechazado, verifique el comentario de rechazo, y suministre el documento de nuevo, en caso de no ser suministrado, la propiedad se le dará de baja el ${dayjs(
            item.drop_at
          ).format("DD/MM/YYYY")}`
        };
      } else {
        return {
          isExpired: false,
          id: item.id,
          message: ``,
          name: item.document_type_name
        };
      }
    });
  } else {
    return [];
  }
};

export interface I_DetailsPropertiesAdapter {
  brochure: PropertyBrochureData;
  cardProperty: ICardProperty;
  principalData: IPrincipalData;
  urlVideos: (string | null)[];
  agents: Agent[];
  documents: Documents[];
  owners: IOwners[];
  alterstate: IAlterestate;
  card: I_RealestateCard[];
  dataLog: IDataLog;
  professionalFees: IProfessionalFees;
  changesLog: ChangeLogs[];
  project: any;
  is_conflictive: number;
  validationDocuments: IValidationDocuments[];
  validationDocumentsAlerts:
    | {
        id: number;
        message: string;
        name: string;
        isExpired: boolean;
      }[]
    | [];
}

interface Documents {
  name: string;
  url: string;
}

interface IValidationDocuments {
  id: number;
  name: string;
  url: string;
  dateExpedition: string;
  status: {
    pending: boolean;
    approved: boolean;
    rejected: boolean;
  };
  status_comment: string | null;
  validated_at: string | null;
  has_alert: boolean;
  message_alert: string | null;
}

interface IPrincipalData {
  remaxGlobal: RemaxGlobalStatusSync;
  hasRestorableUnits: boolean;
  id: number;
  is_collection: boolean;
  is_project: boolean;
  parent_id: number;
  title: string;
  address: string;
  likes_counter: number | string;
  views_counter: number | string;
  leadCounts: ILeadCount[];
  getLeadCount?: (name: string) => string | number | undefined;
  is_conflictive: number;
  shares_counter: number | string;
  location: string;
  pictures: string[];
  description: string;
  business_type: string;
  businesstype_id: number;

  realstatetype_id: number;
  delivers?: string;
  price: { label: string; value: any }[];
  virtual_folders?: {
    dropbox: string | null;
    google_drive: string | null;
  };
  bathrooms: number | null;
  half_bathrooms: number | string;
  bedrooms: number | null;
  latitude: number;
  longitude: number;
  general_information: {
    city: string;
    sector: string;
    ref_point: string;
    property_status: string;
    property_use: string;
    type_of_arrangement: string;
    business_details: string;
    escrow_name: string | null;
    delivers?: string;
    position: string | null;
  };
  property_characteristics: {
    label: string;
    value: any;
  }[];
  improvements: string[];
  property_status: TPROPERTIES_STATUS_OBJECT;
  parking_spots: number | null;
  sqm_construction: string | null;
  sqm_land: string | null;
  pumps: string | null;
  floor_level: string | null;
  floors_total: number | string;
  //   changesLog: Change[];
  realstate_type: string;
  virtual_tour: string | null;
  eng_description: string | null;
  is_inhabited: string;
  name: string;
  total_views: number | string;
  important_alert_message: string;
  has_important_alert: number;
  visit: number;
  maintenance_fee: string;
}

interface ILeadCount {
  name: string;
  total_count: string;
}

interface IOwners {
  id: number;
  name: string;
  email: string;
  phoneNumber: string;
  is_conflictive: number;
}

interface IDataLog {
  expires_property: string | null;
  created_property: string | null;
  property_creator: string | null;
  last_modified_date: string | null;
  last_user_modified_property: string | null;
  property_publication_date: string | null;
  property_user_published: string | null;
  property_dropped_date: string | null;
  last_user_dropped_property: string | null;
  property_resolve_conflict_date: string | null;
  last_user_resolve_conflict_property: string | null;
  property_out_negotiation_date: string | null;
  property_out_negotiation_days: string | null;
  property_reactivation_date: string | null;
  last_user_reactivated_property: string | null;
  activated: string | null;
  resolved_conflict_by: string | null;
  conflict_resolver: string | null;
}

interface IAlterestate {
  is_sync: boolean;
  is_published: boolean;
  commission: number;
  is_failed: any;
}

interface IProfessionalFees {
  total_commission: string;
  guaranteed_commission: string;
  lease_commission: string | null;
}

export interface ChangeLogs {
  name_autor: string;
  date: string;
  changes: Changes;
}

export interface Changes {
  name: Name;
  price: Price;
  images: Images;
  sector: Sector;
  videos: Videos;
  address: Address;
  latitude: Latitude;
  documents: DocumentsChange;
  longitude: Longitude;
  description: Description;
  businesstype: Businesstype;
}

type variant = "arrow" | "only-message" | "see-more" | "multimedia";
interface variantChanges {
  variant: variant;
  name?: string;
  show?: boolean;
}
export interface Name extends variantChanges {
  new: string;
  old: string;
}

export interface Price extends variantChanges {
  new: string;
  old: string;
}

export interface Images extends variantChanges {
  total: number;
  uploaded: number;
}

export interface Sector extends variantChanges {
  new: string;
  old: string;
}

export interface Videos extends variantChanges {
  total: number;
  uploaded: number;
}

export interface Address extends variantChanges {
  new: string;
  old: string;
}

export interface Latitude extends variantChanges {
  new: string;
  old: number;
}

export interface DocumentsChange extends variantChanges {
  docs: string;
}

export interface Longitude extends variantChanges {
  new: string;
  old: number;
}

export interface Description extends variantChanges {
  new: string;
  old: string;
}

export interface Businesstype extends variantChanges {
  new: string;
  old: string;
}
